module.exports = __webpack_public_path__ + "img/circle-new.d6e6c9ff.svg";